export default "__VITE_ASSET__r0mF9Yr___"